export default "{\n    \"emptyState\": \"No especificado\"\n}\n"